import * as Slider from '@radix-ui/react-slider';
import { Label } from '@/components/ui/label';

type FormRangeFieldProps = {
  id: string;
  label: string;
  description?: string;
  minValue: number;
  maxValue: number;
  onMinChange: (value: number) => void;
  onMaxChange: (value: number) => void;
  rangeMin: number;
  rangeMax: number;
  step: number;
  minLabel?: string;
  maxLabel?: string;
  formatValue?: (value: number) => string;
};

export function FormRangeField({
  id,
  label,
  description,
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
  rangeMin,
  rangeMax,
  step,
  minLabel = 'Min',
  maxLabel = 'Max',
  formatValue = (v) => `${v}s`,
}: FormRangeFieldProps) {
  return (
    <div className="grid gap-1.5">
      <Label htmlFor={id} className="font-medium text-gray-900">
        {label}
      </Label>
      {description && (
        <p className="text-detail text-gray-500 leading-tight">{description}</p>
      )}
      <div className="pt-1 pb-2">
        <Slider.Root
          id={id}
          value={[minValue, maxValue]}
          min={rangeMin}
          max={rangeMax}
          step={step}
          onValueChange={([newMin, newMax]) => {
            if (newMin !== minValue) onMinChange(newMin);
            if (newMax !== maxValue) onMaxChange(newMax);
          }}
          className="relative flex h-5 w-full touch-none select-none items-center"
        >
          <Slider.Track className="relative h-1.5 w-full grow rounded-full bg-gray-200">
            <Slider.Range className="absolute h-full rounded-full bg-gray-900" />
          </Slider.Track>
          <Slider.Thumb
            className="block size-4 rounded-full bg-white border-2 border-gray-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-1"
            aria-label={`${minLabel} value`}
          />
          <Slider.Thumb
            className="block size-4 rounded-full bg-white border-2 border-gray-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-1"
            aria-label={`${maxLabel} value`}
          />
        </Slider.Root>
        <div className="flex justify-between mt-1">
          <span className="text-detail text-gray-500">{minLabel}: {formatValue(minValue)}</span>
          <span className="text-detail text-gray-500">{maxLabel}: {formatValue(maxValue)}</span>
        </div>
      </div>
    </div>
  );
}
